import * as t from 'utils/combinatorTypes';
import { FIELDS_MATCH_TOGGLE_IDS } from '../YesNoSplitEditor/YesNoSplitEditor.constants';

export const FIELDS_MATCH_EMPTY_CRITERIA_PROPERTY = {
  comparatorType: '',
  dataType: '',
  field: '',
  fieldType: '',
  value: '',
};

export const FIELDS_MATCH_EMPTY_SEARCH_COMBO = {
  combinator: t.AND,
  searchQueries: [FIELDS_MATCH_EMPTY_CRITERIA_PROPERTY],
};

export const FIELDS_MATCH_EMPTY_SEARCH_QUERY = {
  dataType: '',
  searchCombo: FIELDS_MATCH_EMPTY_SEARCH_COMBO,
};

export const FIELDS_MATCH_EMPTY_SEARCH_GROUP = {
  combinator: t.OR,
  searchQueries: [FIELDS_MATCH_EMPTY_SEARCH_QUERY],
};

export const FIELDS_MATCH_EMPTY_SEARCH_GROUP_WITH_ALL = {
  combinator: t.AND,
  searchQueries: [FIELDS_MATCH_EMPTY_SEARCH_QUERY],
};

export const DEFAULT_FIELDS_MATCH_EMPTY_SEARCH_QUERY = {
  combinator: t.OR,
  searchQueries: [FIELDS_MATCH_EMPTY_SEARCH_GROUP],
};

export const DEFAULT_FIELDS_MATCH_EMPTY_SEARCH_QUERY_WITH_ALL = {
  combinator: t.AND,
  searchQueries: [FIELDS_MATCH_EMPTY_SEARCH_GROUP_WITH_ALL],
};

export const FIELDS_MATCH_EDITOR_TEST_ID = 'fields-match-editor';
export const YES_NO_PREVIEW_BUTTON_TEST_ID = 'yes-no-preview-button';

export const LOCAL_MATCH_TRIGGERING_EVENT_FILTERS = [
  {
    name: 'All user properties and events',
    id: FIELDS_MATCH_TOGGLE_IDS.CONTACT_PROFILE,
    value: FIELDS_MATCH_TOGGLE_IDS.CONTACT_PROFILE,
  },
  {
    name: 'Only the event that triggers this journey',
    id: FIELDS_MATCH_TOGGLE_IDS.TRIGGERING_EVENT,
    value: FIELDS_MATCH_TOGGLE_IDS.TRIGGERING_EVENT,
  },
];

export const FIELDS_QUERY_TYPE = 'JourneyStudio';
